import { FILTERS_MICROFRONTEND_ALIAS } from '@/app/shared/constants/microfrontendAliases';
import { useApplicationContext } from '@/app/shared/context/ApplicationContext';
import { type MicrofrontendAliases } from '@/app/shared/types/MicrofrontendAliases';
import { type MicrofrontendManifest } from '@/app/shared/types/MicrofrontendManifest';

export const useFiltersMicrofrontend = (): MicrofrontendManifest | null | undefined => {
  const { config } = useApplicationContext();

  const mfAliases = config.get<MicrofrontendAliases>('mfAliases');

  return mfAliases?.[FILTERS_MICROFRONTEND_ALIAS];
};
